<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">服务提供商</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">架构的高级描述</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">运行全节点</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">设置exchaincli</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">休息 API</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">FAX SDK 交易签名</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div id="box1" class="p1">服务提供商</div>
      <div class="p3">我们将“服务提供商”定义为为最终用户提供服务的实体，这些服务涉及 FaxChain 区块链内的某种形式的交互。更具体地说，本文档将重点关注与代币的交互。</div>
      <div class="p3">本节不涉及想要提供轻客户端功能的钱包构建者。服务提供商应充当所有 FaxChain 区块链最终用户的可信联系人。</div>
      <div id="box2" class="p2">架构的高级描述</div>
      <div class="p3">需要考虑三个主要部分：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li>全节点：与区块链网络交互。</li>
          <li>Rest Server：它充当 HTTP 调用的中继器。</li>
          <li>Rest API：为 Rest Server 定义可用的端点。</li>
        </ul>
      </div>
      <div id="box3" class="p2">运行全节点</div>
      <div class="p4">安装和配置</div>
      <div class="p3">我们将描述在 FaxChain 网络中运行全节点并与之交互的步骤。对于其他基于 SDK 的区块链，流程应该类似。</div>
      <div class="p3">首先，您需要安装软件。</div>
      <div class="p3">然后，您可以开始运行全节点（testnet）。</div>
      <div class="p4">命令行界面</div>
      <div id="box4" class="p2">设置exchaincli</div>
      <div class="p4">请检查您是否始终使用最新的稳定版本exchaincli。</div>
      <div class="p3"><span>exchaincli</span> 是使您能够与运行在 FaxChain 网络上的节点进行交互的工具，无论您是否自己运行它。让我们正确设置它。</div>
      <div class="p3">为了设置 <span>exchaincli</span> ，请使用以下命令：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config < flag > < value ></div>
        </div>
      </div>
      <div class="p3">它允许您为每个给定标志设置默认值。</div>
      <div class="p3">首先，设置要连接的全节点地址：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config node < host >:< port ></div>
          <div style="padding:5px 0 5px 0"></div>
          <div style="padding:5px 0 5px 0">// example: exchaincli config node https://35.176.62.211:26657</div>
        </div>
      </div>
      <div class="p3">如果您运行自己的全节点，只需tcp://localhost:26657用作地址。</div>
      <div class="p3"><span>--trust-node</span> 然后，让我们设置标志的默认值：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config trust-node false</div>
          <div style="padding:5px 0 5px 0"></div>
          <div style="padding:5px 0 5px 0">// Set to true if you run a light-client node, false otherwise</div>
        </div>
      </div>
      <div class="p3">最后，让我们设置 <span>chain-id</span> 要与之交互的区块链：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config chain-id exchain-778787</div>
        </div>
      </div>
      <div class="p3">接下来，您将找到一些有用的 CLI 命令来与全节点交互。</div>
      <div class="p4">创建密钥对</div>
      <div class="p3">生成新密钥（默认 secp256k1 椭圆曲线）：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli keys add < your_key_name ></div>
        </div>
      </div>
      <div class="p3">系统将要求您为此密钥对创建一个密码（至少 8 个字符）。这将返回下面列出的信息：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li><span>NAME</span> : 你的钥匙的名字。</li>
          <li><span>TYPE</span> ：您的密钥类型，始终为local。</li>
          <li><span>ADDRESS</span> ： 你的地址。用于接收资金。</li>
          <li><span>PUBKEY</span> : 你的公钥。对验证者有用。</li>
          <li><span>MNEMONIC</span> : 24 个单词的短语。将此助记符保存在安全的地方。它用于在您忘记密码时恢复您的私钥。</li>
        </ul>
      </div>
      <div class="p3">您可以通过键入以下内容查看所有可用的密钥：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli keys list</div>
        </div>
      </div>
      <div class="p4">检查余额</div>
      <div class="p3">在您的地址收到代币后，您可以通过键入以下内容查看您的帐户余额：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli query account < YOUR_ADDRESS ></div>
        </div>
      </div>
      <div class="p3">*注意：当您查询零代币的账户余额时，您会得到这个错误：在该状态下没有找到地址为 < YOUR_ADDRESS > 的账户。这是意料之中的！我们正在努力改进我们的错误消息。</div>
      <div class="p4">通过 CLI 发币</div>
      <div class="p3">这是通过 CLI 发币的命令：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli tx send < from_key_or_address > < to_address > < amount > \</div>
          <div style="padding:5px 0 5px 25px">--chain-id=< name_of_testnet_chain ></div>
        </div>
      </div>
      <div class="p3">参数：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li><span>< from_key_or_address ></span> ：发送帐户的密钥名称或地址。</li>
          <li><span>< to_address ></span> : 收件人地址。</li>
          <li><span>< amount ></span> ：该参数接受格式 <span>< value | coinName ></span> ，如10faucetToken。</li>
        </ul>
      </div>
      <div class="p3">标志：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li><span>--chain-id</span> ：此标志允许您指定链的 id。不同的测试网链和主链会有不同的id。</li>
        </ul>
      </div>
      <div class="p4">帮助</div>
      <div class="p3">如果您需要做其他事情，您可以运行的最佳命令是：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli</div>
        </div>
      </div>
      <div class="p3">它将显示所有可用的命令。对于每个命令，您可以使用--help标志来获取更多信息。</div>
      <div id="box5" class="p2">休息 API</div>
      <div class="p3">Rest API 文档收集了可用于与完整节点交互的所有可用端点。</div>
      <div class="p3">为了给开发人员更多的灵活性，FaxChain 社区提供了生成未签名交易、使用不同 API 端点对其进行签名和广播的能力。例如，这允许服务提供商使用他们自己的签名机制。</div>
      <div id="box6" class="p2">FAX SDK 交易签名</div>
      <div class="p3">FaxChain SDK 交易签名是一个相当简单的过程。</div>
      <div class="p3">每个 FaxChain 交易都有一个规范的 JSON 表示。Stargate REST 接口提供交易的exchaincli规范 JSON 表示，它们的“广播”功能将通过氨基（类似 protobuf 的编码器/解码器）对翻译进行编码。</div>
      <div class="p3">签署消息时需要了解的事项：</div>
      <div class="p3">格式如下</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">{</div>
          <div style="padding:5px 0 5px 35px">"account_number": XXX,</div>
          <div style="padding:5px 0 5px 35px">"chain_id": XXX,</div>
          <div style="padding:5px 0 5px 35px">"fee": XXX,</div>
          <div style="padding:5px 0 5px 35px">"sequence": XXX,</div>
          <div style="padding:5px 0 5px 35px">"memo": XXX,</div>
          <div style="padding:5px 0 5px 35px">"msgs": XXX</div>
          <div style="padding:5px 0 5px 0">}</div>
        </div>
      </div>
      <div class="p3">签名者必须提供 <span>"chain_id"</span> 和 <span>"account number"</span> <span>"sequence number"</span> </div>
      <div class="p3">和字段将由 transactioncomposer 接口提供 <span>"fee"</span> <span>"msgs"</span> <span>"memo"</span> </div>
      <div class="p3">和字段可以直接从区块链查询或缓存在本地 <span>"account_number"</span> <span>"sequence"</span> 弄错这些数字以及链 ID 是无效签名错误的常见原因。您可以使用序列号递增的未提交事务序列加载完整节点或验证器的内存池，它通常会做正确的事情。</div>
      <div class="p3">在签名之前，所有密钥都按字典顺序排序，并且从 JSON 输出中删除所有空格。</div>
      <div class="p3">签名编码是 ECDSA 和的 64 字节串联（即 r || s），其中 s 在字典上小于其倒数，以防止延展性。这类似于以太坊，但没有用于 PubKey 恢复的额外字节，因为 Tendermint 假定始终提供 PubKey。</div>
      <div class="p3">签名交易中的签名和公钥示例：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">{</div>
          <div style="padding:5px 0 5px 35px">"type": "auth/StdTx",</div>
          <div style="padding:5px 0 5px 35px">"value": {</div>
          <div style="padding:5px 0 5px 55px">"msg": [...],</div>
          <div style="padding:5px 0 5px 55px">"signatures": [</div>
          <div style="padding:5px 0 5px 75px">{</div>
          <div style="padding:5px 0 5px 95px">"pub_key": {</div>
          <div style="padding:5px 0 5px 115px">"type": "tendermint/PubKeySecp256k1",</div>
          <div style="padding:5px 0 5px 115px">"value": XXX</div>
          <div style="padding:5px 0 5px 95px">},</div>
          <div style="padding:5px 0 5px 95px">"signature": XXX</div>
          <div style="padding:5px 0 5px 75px"> }</div>
          <div style="padding:5px 0 5px 55px">],</div>
          <div style="padding:5px 0 5px 35px">}</div>
          <div style="padding:5px 0 5px 0">}</div>
        </div>
      </div>
      <div class="p3">一旦正确生成签名并将其插入 JSON 中，则生成的交易可以通过客户端命令广播到网络。</div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">服务提供商</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">架构的高级描述</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">运行全节点</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">设置exchaincli</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">休息 API</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">FAX SDK 交易签名</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceProviders',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
span
  padding: 2px 5px
  color: red
  border: 1px solid #ccc
  font-size: 12px
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>